<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">
        <a-form-model layout="vertical" :model="paramData">
          <a-form-model-item label="用户编号"
            ><span>
              {{ paramData.userNo }}
            </span>
          </a-form-model-item>
          <a-form-model-item label="姓名"
            ><a-input v-model="paramData.userName" placeholder="姓名"
          /></a-form-model-item>
          <a-form-model-item label="联系电话"
            ><a-input v-model="paramData.telPhone" placeholder="联系电话"
          /></a-form-model-item>
          <a-form-model-item
            ><a-button type="primary" @click="save"
              >保存</a-button
            ></a-form-model-item
          >
        </a-form-model>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "AdminBaseSetting",
  data() {
    return {
      userInfo: {},
      paramData: {
        userNo: "",
        userName: "",
        telPhone: "",
        id: ""
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.paramData.userName = this.userInfo.userName;
    this.paramData.telPhone = this.userInfo.telPhone;
    this.paramData.userNo = this.userInfo.userNo;
    this.paramData.id = this.userInfo.id;
  },
  methods: {
    ...mapActions(["SetUserInfo"]),
    save() {
      this.$http.systemBksApi.modifySystemUser(this.paramData).then(res => {
        if (res.result == 0) {
          this.$message.success(res.msg);
          this.userInfo.userName = this.paramData.userName;
          this.SetUserInfo(this.userInfo);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
